"use client";

import React from "react";

import PMIComponent from "@/app/components/private-medical-insurance";
import PMIProvider from "@/app/components/private-medical-insurance/provider/private-medical-insurance.provider";
import { PrivateMedicalInsuranceCmsDataType } from "@/app/components/private-medical-insurance/types/private-medical-insurance.type";

function PMIPage({
  cmsData,
}: Readonly<{ cmsData: PrivateMedicalInsuranceCmsDataType }>) {
  return (
    <PMIProvider initialValue={cmsData}>
      <PMIComponent />
    </PMIProvider>
  );
}

export default PMIPage;
